import { compileBreakpoints } from '@codex/helpers';
import themes, { resolveByTheme } from '@codex/themes';
import deepMerge from 'deepmerge';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { LAYOUT_2_0 } from './constants';

const originalTheme = resolveByTheme(theme => themes[theme], 'brightworld');

const homepageTheme = deepMerge(
  originalTheme,
  {
    breakpoints: {
      tight: compileBreakpoints([
        [500, 1239]
      ]),
      wrapGroup: compileBreakpoints([
        [0, 920]
      ]),
      wrapItems: compileBreakpoints([
        [0, 599]
      ]),
      /**
       * Use as least breakpoints as possible. Homepage goes though all of them on every resize.
       * First matched breakpoint will be applied.
       */
      forcedLayout: {
        [LAYOUT_2_0]: () => window.matchMedia(compileBreakpoints([[380, 599]])).matches
      }
    },
    fonts: {
      default: {
        fontFamily: '\'Gotham A\', \'Gotham B\', sans-serif'
      }
    },
    fontWeights: {
      bold: 500
    }
  }
);

const Wrapper = styled.div`
  ${({ theme }) => theme.fonts.default};
`;

export const HomepageThemeProvider = props => (
  <ThemeProvider theme={homepageTheme}>
    <Wrapper>
      {props.children}
    </Wrapper>
  </ThemeProvider>
);

HomepageThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};
